import { $Qll, $Q } from '../utils/querySelector';

/**
 * @author Michael Ballen <michael.ballen@gradiweb.com>
 */
class Accordion {

  /**
 * Assign accordion component
 * @author Michael Ballen <michael.ballen@gradiweb.com>
 */
  constructor(items) {
    this.selector = items
    this.accordionItems = $Qll(items);

    if (this.accordionItems) {
      this._init();
    }
  }

  /**
   * Init accordion functionality
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   */
  _init() {
    this.itemClick();
  }

  /**
   * Liten when accordion item is clicked
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   * @see validateItem
   */
  itemClick() {
    this.accordionItems.forEach(accordionItem => {
      const itemTitle = $Q(`${this.selector}-title`, accordionItem);
      itemTitle.addEventListener("click", this.validateItem.bind(this, accordionItem));
    });
  }

  /**
   * Validate if item is true or false
   * @param {node} -Accordion item clicked
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   * @see openCloseItem
   * @see closeItems
   */
  validateItem(item) {
    if (item.dataset.active === "true") {
      this.openCloseItem(item, "close");
    } else {
      /* this.closeItems(); */
      this.openCloseItem(item, "open");
    }
  }

  /**
   * Set value in dataset active for each accordion item
   * @param {node} -Accordion item clicked
   * @param {String} -Open or Close
   * @author Michael Ballen <michael.ballen@gradiweb.com> 
   */
  openCloseItem(item, action) {
    if (action === "close") {
      item.dataset.active = "false";
    } else {
      item.dataset.active = "true";
    }
  }

  /**
   * Close all accordion items
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   */
  closeItems() {
    this.accordionItems.forEach(element => {
      element.dataset.active = "false";
    })
  }

}

export { Accordion };